import { Box, Heading } from "@chakra-ui/react";
import React, { useState } from "react";
import LoginPhoneNumber from "./LoginPhoneNumber";
import VerifyPhoneNumber from "./VerifyPhoneNumber";

const Authentication = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sentOTP, setSentOTP] = useState(false);

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    const regex = /^[0-9\b]{0,10}$/;
    if (regex.test(value)) {
      setPhoneNumber(value);
    }
  };

  return (
    <Box
      maxW={{ base: "95%", sm: "90%", md: "30%" }}
      mx="auto"
      mt={"5rem"}
      p={10}
      marginTop="200px"
      borderWidth={1}
      borderRadius="lg"
      boxShadow="lg"
      backgroundColor={"white"}
    >
      <Heading as="h1" size="lg" textAlign="center" mb={6}>
        {sentOTP ? "Verify OTP" : "Login to Atlas"}
      </Heading>

      {sentOTP ? (
        <VerifyPhoneNumber
          phoneNumber={phoneNumber}
          handlePhoneChange={handlePhoneChange}
        />
      ) : (
        <LoginPhoneNumber
          phoneNumber={phoneNumber}
          handlePhoneChange={handlePhoneChange}
          setSentOTP={setSentOTP}
        />
      )}
    </Box>
  );
};

export default Authentication;
